<template>
  <div>
    <v-card
      v-if="!error"
      outlined
      class="pa-2 d-flex align-center gap-4 rounded-lg"

    >
      <v-progress-circular
        v-if="loading"
        indeterminate
        size="40"
        class="pa-1"
      />
      <v-icon v-else size="40">
        {{ deploymentStatusMap[deployment?.status]?.icon }}
      </v-icon>
      <div>
        <h6 class="mb-0">
          {{ deploymentStatusMap[deployment?.status]?.text }}
        </h6>
        <p class="mb-0 lh-1">
          Atualizado
          {{
            [new Date(deployment?.buildingAt || deployment?.createdAt)]
              | dateDiff(true)
          }}
        </p>
      </div>
      <v-spacer></v-spacer>
      <v-btn @click="viewOnVercel" small color="primary" text>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-card>

    <v-alert v-if="error" type="error" class="mb-0 mt-1" dense>
      {{ error }}
    </v-alert>
  </div>
</template>

<script>
import platformService from "@/services/admin/platform";

export default {
  name: "PlatformDeploymentStatus",

  props: {
    platform: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      error: null,
      deployment: null,
      deploymentStatusMap: {
        BUILDING: {
          text: "Preparando para publicação",
          color: "warning",
          icon: "mdi-wrench",
        },
        READY: {
          text: "Publicado com sucesso",
          color: "success",
          icon: "mdi-check",
        },
        INITIALIZING: {
          text: "Iniciando publicação",
          color: "info",
          icon: "mdi-clock",
        },
        QUEUED: {
          text: "Em fila para publicação",
          color: "warning",
          icon: "mdi-clock",
        },
      },
    };
  },

  methods: {
    async createDeployment() {
      try {
        this.loading = true;
        const response = await platformService.createDeployment(
          this.platform.id
        );
        this.deployment = response.deployment;
      } catch (error) {
        this.error = error.message || "Erro ao criar implantação";
      } finally {
        this.loading = false;
      }
    },
    async getDeployment() {
      try {
        this.loading = true;
        const response = await platformService.getDeployment(this.platform.id);
        this.deployment = response.deployment;
      } catch (error) {
        this.error = error.message || "Erro ao carregar status de implantação";
      } finally {
        this.loading = false;
      }
    },
    async updateDeployment() {
      if (this.deployment?.status === "READY" || !!this.error) return;
      await this.getDeployment();
      setTimeout(() => {
        this.updateDeployment();
      }, 10000);
    },
    viewOnVercel() {
      const baseUrl = `https://vercel.com/ticket-me/${this.platform.deploymentId}/${this.deployment.id}`;
      window.open(baseUrl, "_blank");
    },
  },
  async mounted() {
    await this.getDeployment();
    this.updateDeployment();
  },
};
</script>
